import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Sidebar from './component/Sidebar';

function Clients(){
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const base = 'https://jojomarket.ne/adminfood/';
  const urlList = base + 'functionclient.php?getclients';

  const loadClients = async () => {
    try {
      const res = await axios.get(urlList);
      setClients(res.data || []);
    } catch (error) {
      console.error('Erreur chargement clients:', error);
    }
  };

  useEffect(() => {
    loadClients();
  }, []);

  const openHistory = async (client) => {
    setSelectedClient(client);
    setLoading(true);
    try {
      const url = `${base}functionclient.php?client_history&idclient=${client.idclient}`;
      const res = await axios.get(url);
      setHistory(res.data || []);
      // Show modal
      const modal = new window.bootstrap.Modal(document.getElementById('historyModal'));
      modal.show();
    } catch (error) {
      console.error('Erreur chargement historique:', error);
      alert('Erreur lors du chargement de l\'historique');
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (statu) => {
    if (statu === 0) {
      return <span className="badge bg-danger">Non Validé</span>;
    } else if (statu === 1) {
      return <span className="badge bg-warning">En cours</span>;
    } else if (statu === 2) {
      return <span className="badge bg-success">Livré</span>;
    }
    return <span className="badge bg-secondary">Inconnu</span>;
  };

  const filteredClients = clients.filter(client => {
    if (!searchTerm) return true;
    const search = searchTerm.toLowerCase();
    return (
      client.nom.toLowerCase().includes(search) ||
      client.telephone.includes(search) ||
      (client.email && client.email.toLowerCase().includes(search))
    );
  });

  return (
    <div className="gutter-default">
      <Sidebar />
      <div className="main-content" style={{ marginLeft: '250px', padding: '20px' }}>
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card my-4">
                <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                  <div className="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3">
                    <h6 className="text-white text-capitalize ps-3">Gestion des Clients</h6>
                  </div>
                </div>
                <div className="card-body px-0 pb-2">
                  {/* Search bar */}
                  <div className="px-4 pb-3">
                    <div className="input-group input-group-outline">
                      <span className="input-group-text">
                        <i className="fas fa-search"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Rechercher par nom, téléphone ou email..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                      {searchTerm && (
                        <button
                          className="btn btn-outline-secondary"
                          type="button"
                          onClick={() => setSearchTerm('')}
                        >
                          <i className="fas fa-times"></i>
                        </button>
                      )}
                    </div>
                  </div>

                  {/* Clients table */}
                  <div className="table-responsive p-0">
                    <table className="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            ID
                          </th>
                          <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                            Nom
                          </th>
                          <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Téléphone
                          </th>
                          <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Email
                          </th>
                          <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Nombre de commandes
                          </th>
                          <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredClients.length === 0 ? (
                          <tr>
                            <td colSpan="6" className="text-center py-4">
                              {searchTerm ? 'Aucun client trouvé' : 'Aucun client enregistré'}
                            </td>
                          </tr>
                        ) : (
                          filteredClients.map((client) => (
                            <tr key={client.idclient}>
                              <td>
                                <div className="d-flex px-2 py-1">
                                  <div className="d-flex flex-column justify-content-center">
                                    <h6 className="mb-0 text-sm">#{client.idclient}</h6>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <p className="text-xs font-weight-bold mb-0">{client.nom}</p>
                              </td>
                              <td className="align-middle text-center text-sm">
                                <span className="text-secondary text-xs font-weight-bold">
                                  {client.telephone}
                                </span>
                              </td>
                              <td className="align-middle text-center text-sm">
                                <span className="text-secondary text-xs font-weight-bold">
                                  {client.email || '-'}
                                </span>
                              </td>
                              <td className="align-middle text-center">
                                <span className="badge badge-sm bg-gradient-info">
                                  {client.nb_commandes}
                                </span>
                              </td>
                              <td className="align-middle text-center">
                                <button
                                  className="btn btn-sm btn-outline-primary"
                                  onClick={() => openHistory(client)}
                                  disabled={loading}
                                >
                                  <i className="fas fa-history me-1"></i>
                                  Historique
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* History Modal */}
      <div
        className="modal fade"
        id="historyModal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="historyModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header bg-gradient-primary">
              <h5 className="modal-title text-white" id="historyModalLabel">
                <i className="fas fa-history me-2"></i>
                Historique des commandes - {selectedClient?.nom}
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Chargement...</span>
                  </div>
                </div>
              ) : history.length === 0 ? (
                <div className="text-center py-5">
                  <p className="text-muted">Aucune commande pour ce client</p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>N° Commande</th>
                        <th>Date</th>
                        <th>Adresse</th>
                        <th>Produits</th>
                        <th>Montant</th>
                        <th>Statut</th>
                        <th>Livreur</th>
                      </tr>
                    </thead>
                    <tbody>
                      {history.map((commande) => (
                        <tr key={commande.idcommande}>
                          <td>
                            <strong>#{commande.idcommande}</strong>
                          </td>
                          <td>
                            {new Date(commande.datecommande).toLocaleString('fr-FR')}
                          </td>
                          <td>
                            <small>{commande.adresse || '-'}</small>
                            {commande.latitude && commande.longitude && (
                              <div>
                                <a
                                  href={`https://maps.google.com/?q=${commande.latitude},${commande.longitude}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn btn-sm btn-link p-0"
                                >
                                  <i className="fas fa-map-marker-alt me-1"></i>
                                  Voir sur la carte
                                </a>
                              </div>
                            )}
                          </td>
                          <td>
                            <div className="d-flex flex-column">
                              {commande.listeproduit.map((produit, idx) => (
                                <small key={idx}>
                                  {produit.nomproduit} (x{produit.quantite}) - {produit.prix.toLocaleString('fr-FR')} FCFA
                                </small>
                              ))}
                            </div>
                          </td>
                          <td>
                            <strong className="text-success">
                              {commande.prix.toLocaleString('fr-FR')} FCFA
                            </strong>
                            {commande.encaisser > 0 && (
                              <div>
                                <small className="text-muted">
                                  Encaissé: {commande.encaisser.toLocaleString('fr-FR')} FCFA
                                </small>
                              </div>
                            )}
                          </td>
                          <td>{getStatusBadge(commande.statu)}</td>
                          <td>
                            {commande.livreur ? (
                              <div>
                                <small>
                                  <strong>{commande.livreur.nomlivreur}</strong>
                                  <br />
                                  {commande.livreur.telephone}
                                </small>
                              </div>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Clients;

